<template>
    <div class="modal is-active" >
        <div class="modal-background" />
        <div class="modal-content">
            <div class="box">
                <div class="modal-header">
                    <div v-if="unlink" class="pb-4">
                        <div class="notification secondary-font">
                            Al desvincular el compte de Eduloc360 del servei d'autenticació necessites confirmar les dades d'accés per tal de poder utilitzar el teu compte Eduloc360 sense l'autenticació remota. <br>  Bàsicament és necessari que <strong>assignis una contrassenya</strong> al teu compte i, si vols, una imatge. Si cal pots modificar, també, altres dades.
                        </div>
                    </div>
                </div>
                <div class="modal-body py-5 px-5">
                    <div class="columns is-vcentered ">
                        <div class="column is-3">
                            <user-profile-image-upload :image.sync="registrationData.avatar" :can-edit="true" class="pt-4" />
                        </div>
                        
                        <div class="columns is-multiline">
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">{{ $t('registration_name') }}</label>
                                    <div class="control has-icons-right">
                                        <input class="input eduloc" type="text" v-model="registrationData.name" :class="showNameError?'is-danger':''" @change="checkNameField">
                                        <span class="icon is-small is-right" v-if="showNameError">
                                            <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                        </span>
                                    </div>
                                    <p class="help is-danger is-size-7" v-if="showNameError">{{ $t(errorsFound.name) }}</p>
                                </div>
                            </div>
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">{{ $t('registration_surname') }}</label>
                                    <div class="control has-icons-right">
                                        <input class="input eduloc" type="text" v-model="registrationData.surname" :class="showSurnameError?'is-danger':''" @change="checkSurnameField">
                                        <span class="icon is-small is-right" v-if="showSurnameError">
                                            <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                        </span>
                                    </div>
                                    <p class="help is-danger is-size-7" v-if="showSurnameError">{{ $t(errorsFound.surname) }}</p>
                                </div>
                            </div>
                
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">{{ $t('registration_username') }}</label>
                                    <div class="control has-icons-right">
                                        <input class="input eduloc" type="text" v-model="registrationData.username" :class="showUsernameError?'is-danger':''" @change="checkUsernameField">
                                        <span class="icon is-small is-right" v-if="showUsernameError">
                                        <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                        </span>
                                    </div>
                                    <p class="help is-danger is-size-7" v-if="showUsernameError"> {{ $t(errorsFound.username) }}</p>
                                </div>
                            </div>
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">{{ $t('registration_email') }}</label>
                                    <div class="control has-icons-right">
                                        <input class="input eduloc" type="email" v-model="registrationData.email" :class="showEmailError?'is-danger':''" @change="checkEmailField">
                                        <span class="icon is-small is-right" v-if="showEmailError">
                                        <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                        </span>
                                    </div>
                                    <p class="help is-danger is-size-7" v-if="showEmailError">{{ $t(errorsFound.email) }}</p>
                                </div>
                            </div>
                
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">{{ $t('registration_password') }}</label>
                                    <div class="control has-icons-right">
                                        <input class="input eduloc" type="password" v-model="registrationData.password" :class="showPw1Error?'is-danger':''" @change="checkPasswordField">
                                        <span class="icon is-small is-right is-danger" v-if="showPw1Error">
                                        <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                        </span>
                                    </div>
                                    <p class="help is-danger is-size-7" v-if="showPw1Error">{{ $t(errorsFound.pw1) }}</p>
                                </div>
                            </div>
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">{{ $t('registration_password_confirmation') }}</label>
                                    <div class="control has-icons-right">
                                        <input class="input eduloc" type="password" v-model="registrationData.pw2" :class="showPw2Error?'is-danger':''" @change="checkPasswordField"> 
                                        <span class="icon is-small is-right" v-if="showPw2Error">
                                        <i class="fas fa-exclamation-triangle has-text-danger"></i>
                                        </span>
                                    </div>
                                    <p class="help is-danger is-size-7" v-if="showPw2Error">{{ $t(errorsFound.pw2) }}</p>
                                </div>
                            
                            </div>
                </div>
                    </div>
                    
                </div>
                <div class="modal-footer mt-6">
                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <p class="control">
                                    <button class="button is-primary" @click="checkForm">{{ $t('save') }}</button>
                                </p>
                            </div>
                        </div>
                        <div class="level-right">
                            <p class="control">
                                <button class="button" @click="close">{{ $t('cancel') }}</button>
                            </p>
                        </div>
                    </nav>
                </div>
                
            </div>
            
        </div>
        
    </div>
</template>

<script>
import _ from 'underscore';
import { updateMyProfile, checkUsername, checkEmail, } from '@/services/API';
import UserProfileImageUpload from '@/components/UserProfileImageUpload';

export default {
    components: {
        UserProfileImageUpload,
    },
    props: {
        user: {
            type: Object,
            default() {
                return {};
            },
        },
        unlink:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            registrationData: {
                name: this.$store.getters.personalData.name,
                surname: this.$store.getters.personalData.surname,
                email: this.$store.getters.personalData.email,
                username: this.$store.getters.personalData.username,
                password: '',
                pw2: '',
                avatar: this.$store.getters.personalData.avatar ? this.$store.getters.personalData.avatar : '',
            },
            errorsFound: {},
            showRegistration: false,
            ageConsent: false,
            TOSaccepted: false,
            showNameError: false,
            showSurnameError: false,
            showUsernameError: false,
            showEmailError: false,
            showPw1Error: false,
            showPw2Error: false,
        };
    },
    computed: {},
    mounted() {},
    methods: {
        
        close(){
            this.$emit('close');
        },
        async checkForm() {

            if (!this.hasErrors) { //this.$store.dispatch('fetchProfile');
                if (this.unlink) {
                    if (this.registrationData.password.length == 0 || this.registrationData.pw2.length == 0) {
                        this.errorsFound.pw1 = this.$t('registration_error_password')
                        this.showPw1Error = true
                        this.errorsFound.pw2 = this.$t('registration_error_password')
                        this.showPw2Error = true
                        return false
                    }
                    this.registrationData.action = 'unlink';
                }

                // console.log("no errors. sending form")
                await updateMyProfile(this.registrationData).catch((e) => {
                    console.log("error updating user", e)
                })
                    .then((response) => {
                        //console.log(response)
                        
                        if (response && response.status == "200") {
                            // console.log("user updated")
                            this.$store.dispatch('fetchProfile');
                            this.$emit('close');
                            
                        }
                    });

            } else {
                console.log("hi han errors")
            }


        },
        checkNameField() {
            this.errorsFound.name = null
            this.showNameError = false;
            if (!this.registrationData.name.length || !this.registrationData.name.trim()) {
                this.errorsFound.name = this.$t('registration_error_name')
                this.showNameError = true;
                return false
            }
            return true
        },
        checkSurnameField() {
            this.errorsFound.surname = null
            this.showSurnameError = false;
            if (!this.registrationData.surname.length || !this.registrationData.surname.trim()) {
                this.errorsFound.surname = this.$t('registration_error_surname')
                this.showSurnameError = true
                return false
            }
            return true
        },
        async checkUsernameField() {
            this.errorsFound.username = null
            this.showUsernameError = false

            if (!this.registrationData.username || this.registrationData.username.trim().length < 2) {
                this.errorsFound.username = this.$t('registration_error_username_too_short') //"Cal introduir un nom d'usuari de, com a mínim 2, caracters"
                this.showUsernameError = true
                return false
            } else {
                this.registrationData.username = this.registrationData.username.trim()
                await checkUsername({ 'username': this.registrationData.username })
                    .catch((e) => {
                        // console.log('error on check username ', e.data)
                        this.errorsFound.username = this.$t('registration_error_username_already_exists') //"Aquest nom d'usuari ja existeix"
                        this.showUsernameError = true
                        return false
                    })
                    .then((response) => {
                        if (response && response.status == 200) {
                            this.errorsFound.username = null
                            this.showUsernameError = false
                            return true
                        }
                    })
            }
            return false
        },
        async checkEmailField() {
            this.errorsFound.email = null
            this.showEmailError = false

            let isValidEmail;

            if (!this.registrationData.email || this.registrationData.email.trim().length < 2) {
                this.errorsFound.email = this.$t('registration_error_email_innvalid') //"Cal introduir una adreça de correu electrònic vàlida"
                this.showEmailError = true
                return false
            }
            this.registrationData.email = this.registrationData.email.trim()
            // console.log("checking ", this.registrationData.email)
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (regex.test(this.registrationData.email)) {
                await checkEmail({ 'email': this.registrationData.email })
                    .catch((e) => {
                        // console.log('error on check email ', e.data)
                        this.errorsFound.email = this.$t('registration_error_email_already_exists') //"Aquesta adreça de correu electrònic ja exsteix"
                        this.showEmailError = true
                        return false
                    })
                    .then((response) => {
                        if (response && response.status == 200) {
                            this.errorsFound.email
                            this.showEmailError = false
                            return true
                        }
                    })
            } else {
                this.errorsFound.email = this.$t('registration_error_email_innvalid') //"Cal introduir una adreça de correu electrònic vàlida"
                this.showEmailError = true
                return false
            }

            return false

        },
        checkPasswordField() {
            this.errorsFound.pw1 = null
            this.errorsFound.pw2 = null
            this.showPw1Error = false;
            this.showPw2Error = false;

            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,}$/;
            // let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;

            if (this.registrationData.password.length > 0 || this.registrationData.pw2.length > 0) {
                if (this.registrationData.password !== this.registrationData.pw2) {
                    this.errorsFound.pw1 = this.$t('registration_error_pw_different')
                    this.errorsFound.pw2 = this.$t('registration_error_pw_different')
                    this.showPw1Error = true
                    this.showPw2Error = true
                    return false
                }
                else if (regex.test(this.registrationData.password)) {
                    this.errorsFound.pw1 = null
                    this.errorsFound.pw2 = null
                    this.showPw1Error = false;
                    this.showPw2Error = false;
                    return true
                } else {
                    this.errorsFound.pw1 = this.$t('registration_error_password')
                    this.showPw1Error = true
                    this.errorsFound.pw2 = this.$t('registration_error_password')
                    this.showPw2Error = true
                    return false
                }
            } 

            return false

        },
    },
};
</script>

<style scooped>
    .cursor-wait{
        cursor:wait;
    }
    .input{
    border-radius: 6px;
    color: #000000;
    border-color: #000000;
}
.input:not(.is-danger):hover{
    border-radius: 6px;
    color: #000000;
    border-color: #000000;
}


.input::placeholder {
  color: #000000;
}

.label {
  color: #000000;
}

.button[disabled]:hover{
    color: #000000;
    background-color: #ffffff;
}
</style>
